<template>
  <div class="create_company-step-header">
    <i :class="icon" aria-hidden="true"></i>
    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'CreateCompanyStepHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'bi bi-building',
    },
  },
};
</script>
